export default __webpack_public_path__ + "static/media/Kadick_EHB_August_2021.38f613a5.pdf";